import { render } from "./RatesService.vue?vue&type=template&id=37526bdd&scoped=true"
import script from "./RatesService.vue?vue&type=script&lang=js"
export * from "./RatesService.vue?vue&type=script&lang=js"

import "./RatesService.vue?vue&type=style&index=0&id=37526bdd&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-37526bdd"

export default script